import Vue from 'vue'
import routes from './routes'
import Router from 'vue-router'
import beforeEach from './beforeEach'
import afterEach from './afterEach'

Vue.use(Router)

const router = new Router({ routes })

router.beforeEach(beforeEach)

router.afterEach(afterEach)

export default router
